import { on } from "delegated-events";

export default {
  init: () => {
    on("changeDate", "input.first-ticket-date", (e) => {
      const value = e.target.value;

      document.querySelectorAll("input.additional-ticket-date").forEach((input) => {
        input.value = value;
      });
    });

    on("change", "select.first-ticket-court", (e) => {
      const value = e.target.tomselect.getValue();
      document.querySelectorAll("select.additional-ticket-court").forEach((select) => {
        select.tomselect.setValue(value);
      });
    });
  },
};
